<style lang="less" scoped>
  .button-group {
      margin: 0 20px 0 0px;
      display: flex;
  }
</style>
<template>
  <div class="tree-render">
    <ul :style="{ marginLeft: level*10 + 'px' }">
      <li
        v-for="item in list"
        :key="item.key"
        style="padding:3px 0"
      >
        <div class="item">
          <div 
            class="titleContain"
            :class="{
              isClouldSelect: level!==0&&couldSelect
            }"
          >
            <span
              v-show="!item.del"
              class="beforeTitle"
              :class="{
                haveChildren:item.items&&item.items.length>0,
                isExtend: item.expand,
                isClose: !item.expand
              }"
              @click.stop="changeExpend(item)"
            />
            <div
              class="titleContent"
              :class="{ selected: selected===item.id}"
              @click.stop="treeNodeSelected(item)"
            >
              <Checkbox
                v-if="couldCheckout&&level!==0"
                v-model="item.checkout"
                style="margin-right:-5px"
                @on-change="checkBoxChangeItem(item)"
              />
              <p
                :class="{
                  'title-p':!item.del,
                  'title-del-p': item.del,
                  'isSelected': !item.del&&item.selected,
                }"
                :drageNodeType="(item.del)?'del':'parent'"
                :draggable="!item.del&&couldGrag&&level!==0"
                @dragover="allowDrop(arguments,item,'parent')"
                @dragstart="dragFun(item)"
                @dragend="dragendFun"
                @click="level!==0&&!item.del&&couldSelect&&selectedFun(item)"
              >
                <span
                  :drageNodeType="(item.del)?'del':'child'"
                  class="title-1"
                  :class="{'title-cursor':!item.del&&level!==0}"
                >{{ item.name }}</span>                
              </p>
            </div>
          </div>
          <div
            v-show="couldEdit"
            class="title-mark"
            :class="{'line-style':level===1}"
          />
          <div
            class="button-group"
          >
            <div v-if="level===0&&couldFoldAll">
              <Button
                size="small"
                type="text"
                @click="foldAllFun(false)"
              >
                全部折叠
              </Button>
            </div>
            <div v-if="level===0&&couldUnfoldAll">
              <Button
                size="small"
                type="text"
                @click="foldAllFun(true)"
              >
                全部展开
              </Button>
            </div>
            <div v-if="couldEdit">
              <span v-if="!item.del">
                <Button
                  size="small"
                  type="text"
                  @click.stop="addNewOneChild(item,level)"
                >
                  <Icon
                    type="ios-add-circle"
                    size="20"
                  />
                </Button>
                <Button
                  v-if="level!==0"
                  size="small"
                  type="text"
                  @click.stop="editItem(item,level)"
                >
                  <Icon
                    type="ios-build"
                    size="20"
                  />
                </Button>
              </span>
              <Button
                v-if="level!==0"
                size="small"
                type="text"
                @click="treeStartStop(item)"
              >
                <Icon
                  v-if="!item.del"
                  type="ios-eye-off"
                  size="20"
                />
                <Icon 
                  v-else
                  type="ios-eye"
                  size="20"
                />
              </Button>
            </div>
          </div>
        </div>
        <div 
          v-if="couldGrag"
          v-show="item===hoverNode&&item!==gragItem"
          :style="{ marginLeft: (level*10+24) + 'px' }"
        >
          <span 
            v-if="level!==0"
            class="drage-mark"
            @dragover="allowDrop(arguments,item,'brother')"
            @drop="dropFun(item,'brother')"
            @dragover.prevent
          >作为兄弟节点</span>
          <span
            class="drage-mark"
            @dragover="allowDrop(arguments,item,'child')"
            @drop="dropFun(item,'child')"
            @dragover.prevent
          >作为子节点</span>
        </div>
        <div
          v-show="!item.del&&item.items&&item.items.length"
          :class="{
            childrencContainisExtend: item.expand,
            childrencContainisClose: !item.expand,
            'expend-animation': !item.expand,
          }"
        >
          <tree-render
            :allow-drop="allowDrop"
            :grag-item="gragItem"
            :could-grag="couldGrag"
            :dragend-fun="dragendFun"
            :drop-fun="dropFun"
            :drag-fun="dragFun"
            :edit-one="editOne"
            :list="item.items"
            :level="level+1"
            :add-new-one="addNewOne"
            :parent="item"
            :start-stop-use="startStopUse"
            :could-select="couldSelect"
            :could-edit="couldEdit"
            :could-checkout="couldCheckout"
            :check-box-change="checkBoxChange"
            :selected-change="selectedChange"
            :could-fold-all="couldFoldAll"
            :could-unfold-all="couldUnfoldAll"
            :hover-node="hoverNode"
          />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
    import { PropsType } from './fields'
    import { FUNCTION } from './constants'
    export default {
        name:'TreeRender',
        props:PropsType,
        data () {
            return {
                index: 0
            }
        },
        methods: {
            treeNodeSelected (item) {
                const { changeSelected = FUNCTION } = this.callBack
                changeSelected(item)
            },
            changeExpend (data) {
                if(!data.items||data.items.length===0) return;
                data.expand = !data.expand
            },
            leveZeroClick () {
             const { add = FUNCTION } = this.callBack
             add()
            },
            addNewOneChild (data,level) {
               this.addNewOne({ ...data,level })
            },
            editItem (child) {
              this.editOne(this.level,this.parent,child)
            },
            treeStartStop (item) {
              this.startStopUse(this.level,this.parent,item)
            },
            checkBoxChangeItem (data) {
               this.checkBoxChange(data)
            },
            selectedFun (data) {
                this.selectedChange(data)                
            },
        }
    }
</script>

<style lang="less" scoped>
@import './style.less';
</style>
